// Bootstrap pattern for Module Federation
// This dynamic import allows Module Federation to initialize shared modules
// before React and other dependencies are loaded
import('./bootstrap');
